"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeAuditlog_en_us = void 0;
function backofficeAuditlog_en_us() {
    return {
        "backoffice.auditlog.title": "Audit Log",
        "backoffice.auditlog.subtitle": "Here you can track data changes to certain entities.",
        "backoffice.auditlog.user": "Change by",
        "backoffice.auditlog.feature": "Data set",
        "backoffice.auditlog.event": "Event",
        "backoffice.auditlog.targetid": "Target",
        "backoffice.auditlog.diff": "Difference",
        "backoffice.auditlog.createdat": "Date",
        "backoffice.auditlog.owneridnotfound": "Unknown"
    };
}
exports.backofficeAuditlog_en_us = backofficeAuditlog_en_us;
